module.exports = __webpack_public_path__ + "static/media/tax-refund.511a5583.gif";